<template>
  <div class="flex-container">
    <div class="left-container" v-if="labelSettingsData">
      <div class="row-item">
        <div class="cell-item">{{ $t('api_key') }}</div>
        <!-- <div class="cell-item"><TextField
            class="m1"
            :id="'bookingFrom'"
     
            :value="labelSettingsData.ext_api_checksum"
        ></TextField></div> -->
        <input
          type="text"
          class="text-field"
          :value="labelSettingsData.ext_api_checksum"
        />
      </div>
      <div class="row-item">
        <div class="cell-item">{{ $t('artists') }}</div>
        <div class="cell-item">
          {{
            labelSettingsData.ext_api_path +
            clientName +
            "/?action=artists&api_key=" +
            labelSettingsData.ext_api_checksum
          }}
        </div>
      </div>
      <div class="row-item">
        <div class="cell-item">{{ $t('releases') }}</div>
        <div class="cell-item">
          {{
            labelSettingsData.ext_api_path +
            clientName +
            "/?action=releases&api_key=" +
            labelSettingsData.ext_api_checksum
          }}
        </div>
      </div>
      <div class="row-item">
        <div class="cell-item">{{ $t('products') }}</div>
        <div class="cell-item">
          {{
            labelSettingsData.ext_api_path +
            clientName +
            "/?action=products&api_key=" +
            labelSettingsData.ext_api_checksum
          }}
        </div>
      </div>
      <div class="row-item">
        <div class="cell-item">{{ $t('product_tracks') }}</div>
        <div class="cell-item">
          {{
            labelSettingsData.ext_api_path +
            clientName +
            "/?action=productTracks&api_key=" +
            labelSettingsData.ext_api_checksum
          }}
        </div>
      </div>
      <div class="row-item">
        <div class="cell-item">{{ $t('tracks')}} </div>
        <div class="cell-item">
          {{
            labelSettingsData.ext_api_path +
            clientName +
            "/?action=tracks&api_key=" +
            labelSettingsData.ext_api_checksum
          }}
        </div>
      </div>
      <div class="row-item">
        <div class="cell-item">{{ $t('stock') }}</div>
        <div class="cell-item">
          {{
            labelSettingsData.ext_api_path +
            clientName +
            "/?action=stocks&api_key=" +
            labelSettingsData.ext_api_checksum +
            stock
          }}
        </div>
      </div>
      <div class="row-item">
        <div class="cell-item">{{ $t('prices') }}</div>
        <div class="cell-item">
          {{
            labelSettingsData.ext_api_path +
            clientName +
            "/?action=prices&api_key=" +
            labelSettingsData.ext_api_checksum
          }}
        </div>
      </div>
      <div class="row-item">
        <div class="cell-item">{{$t('orders')}}</div>
        <div class="cell-item">
          {{
            labelSettingsData.ext_api_path +
            clientName +
            "/?action=orderss&api_key=" +
            labelSettingsData.ext_api_checksum
          }}
        </div>
      </div>
      <div class="row-item">
        <div class="cell-item">{{ $t('add_orders') }}</div>
        <div class="cell-item">
          {{
            labelSettingsData.ext_api_path +
            clientName +
            "/?action=addOrder&api_key=" +
            labelSettingsData.ext_api_checksum +
            addOrder
          }}
        </div>
      </div>
      <div class="row-item">
        <div class="cell-item">{{$t('get_products_tracks_id_barcode')}}</div>
        <div class="cell-item">
          {{
            labelSettingsData.ext_api_path +
            clientName +
            "/?action=get_products_tracks_id_barcode&&api_key=" +
            labelSettingsData.ext_api_checksum
          }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { MHTTPCL } from "../../../../services/http/http-client";
import TextField from "@plugins/text-field/text-field";
export default {
  props: ["labelSettingsData", "clientName"],
  computed: {
    baseUrl: function () {
      return MHTTPCL.getBaseUrl();
    },
  },
  data: function () {
    return {
      stock: "&product_uuids=<product_UUID>&account_ids=<account_id|account_id|...>",
      addOrder:
        "<any field of our database l_orders table>=<value>&<any field of our database contacts table>=<value>&orderLines=<UUID_of_product>|<order_qty>|<ppu>|<status>&orderLines=<UUID_of_product>|<order_qty>|<ppu>|<status>",
      bookingForm: "booking",
    };
  },
};
</script>
<style scoped>
.flex-container {
  display: flex;
  flex-direction: column;
}
.row-item {
  padding: 0.5em;
  border-bottom: 1px solid #ccc;
  display: flex;
  flex-direction: row;
  /* height: 40px; */
}
.cell-item {
  /* padding:0.5em; */
  text-overflow: ellipsis;
  overflow: hidden;
  /* white-space: nowrap; */
}
.cell-item:first-child {
  min-width: 20%;
  max-width: 20%;
}
.cell-item:nth-child(2) {
  text-align: left;
  word-break: break-all;
}

.text-field {
  border: 1px solid #bbbaba;
  padding: 5px;
  border-radius: 5px;
  width: 100%;
}
.text-field:focus {
  border: 1px solid #bbbaba;
}
</style>
